import {
  FETCH_COUNTRIES,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILED,
  EDIT_COUNTRY,
  EDIT_CITY
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, remove, push, ref, update } from "firebase/database";

export const fetchCountries = () => (dispatch) => {

  const {
    countriesRef
  } = firebase;

  dispatch({
    type: FETCH_COUNTRIES,
    payload: null
  });
  onValue(countriesRef, snapshot => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i]
      });
      dispatch({
        type: FETCH_COUNTRIES_SUCCESS,
        payload: arr
      });
    } else {
      // No countries configured yet - empty list, not an error.
      dispatch({
        type: FETCH_COUNTRIES_SUCCESS,
        payload: []
      });
    }
  }, error => {
    dispatch({
      type: FETCH_COUNTRIES_FAILED,
      payload: error.message
    });
  });
};

export const editCountry = (country, method) => (dispatch) => {
  const {
    countryEditRef
  } = firebase;
  dispatch({
    type: EDIT_COUNTRY,
    payload: { method, country }
  });
  // Returns the underlying Firebase promise so callers can surface write
  // failures (e.g. permission-denied when rules haven't been deployed yet)
  // instead of failing silently.
  if (method === 'Delete') {
    return remove(countryEditRef(country.id));
  } else {
    return set(countryEditRef(country.code), country);
  }
}

export const editCity = (countryCode, city, method) => (dispatch) => {
  const {
    countryCitiesRef,
    countryCityEditRef
  } = firebase;
  dispatch({
    type: EDIT_CITY,
    payload: { countryCode, method, city }
  });
  if (method === 'Add') {
    return push(countryCitiesRef(countryCode), city);
  } else if (method === 'Delete') {
    return remove(countryCityEditRef(countryCode, city.id));
  } else {
    return set(countryCityEditRef(countryCode, city.id), city);
  }
}

// Escritura masiva de campos de ciudad ya normalizados. `changes` es una lista de
// { path, value } (p. ej. { path: 'users/<uid>/city', value: 'MEDELLIN-ANTIOQUIA' }).
// Se aplica en lotes con `update()` multi-ruta (atómico por lote). Sólo un
// `usertype === 'admin'` tiene permiso de escritura sobre users/cars/cartypes.
export const bulkUpdateCityFields = (changes = [], batchSize = 200) => async () => {
  const { database } = firebase;
  let written = 0;
  for (let i = 0; i < changes.length; i += batchSize) {
    const slice = changes.slice(i, i + batchSize);
    const payload = {};
    slice.forEach(({ path, value }) => {
      payload[path] = value;
    });
    // eslint-disable-next-line no-await-in-loop
    await update(ref(database), payload);
    written += slice.length;
  }
  return written;
};
